export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-cloud-line' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-scissors-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-award-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-box-3-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-trophy-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-briefcase-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export const brands = [
  { name: 'Nike', imageSeq: 'brand-nike' },
  { name: 'Jordan', imageSeq: 'brand-jordan' },
  { name: 'Adidas', imageSeq: 'brand-adidas' },
  { name: 'Yeezy', imageSeq: 'brand-yeezy' },
  { name: 'Stussy', imageSeq: 'brand-stussy' },
  { name: 'Supreme', imageSeq: 'brand-supreme' },
  { name: 'Essentials', imageSeq: 'brand-essentials' },
  { name: 'Balenciaga', imageSeq: 'brand-balenciaga' },
  { name: 'Louis Vuitton', imageSeq: 'brand-lv' },
  { name: 'Dior', imageSeq: 'brand-dior' },
  { name: 'Chrome Hearts', imageSeq: 'brand-chrome' },
  { name: 'New Balance', imageSeq: 'brand-nb' },
  { name: "Arc'teryx", imageSeq: 'brand-arc' },
  { name: 'Stone Island', imageSeq: 'brand-si' },
  { name: 'Gallery Dept', imageSeq: 'brand-gd' },
];

export const articles = [
  {
    title: 'Complete CSSBuy Spreadsheet Beginner Guide 2026',
    slug: 'best-cssbuy-spreadsheet-guide',
    excerpt: 'Everything you need to know about using CSSBuy spreadsheets — from finding trusted sellers to navigating shipping options like a pro.',
    icon: 'ri-book-open-line',
  },
  {
    title: 'CSSBuy Shipping Tips & Tricks',
    slug: 'cssbuy-shipping-tips',
    excerpt: 'Master CSSBuy shipping with our comprehensive guide covering lines, pricing, packaging, and customs for every destination.',
    icon: 'ri-ship-line',
  },
  {
    title: 'CSSBuy QC Photos Explained',
    slug: 'cssbuy-qc-guide',
    excerpt: 'Learn how to read QC photos, spot common flaws, and make smart RL/GL decisions with your CSSBuy agent.',
    icon: 'ri-zoom-in-line',
  },
];

export const faqs = [
  {
    question: 'What is a CSSBuy spreadsheet?',
    answer: 'A CSSBuy spreadsheet is a curated collection of product links organized in a shareable document. These spreadsheets help buyers quickly find trusted sellers, popular items, and verified product links across categories like shoes, clothing, and accessories. Our directory aggregates the largest collection of these spreadsheets, updated daily with new finds and community-verified links.',
  },
  {
    question: 'How often are the spreadsheets updated?',
    answer: 'Our spreadsheet directory is updated daily. We continuously verify existing links, remove dead or outdated entries, and add new community-submitted spreadsheets. Each listing shows its last update timestamp so you know exactly how fresh the data is.',
  },
  {
    question: 'Are the sellers in these spreadsheets trusted?',
    answer: 'Yes. Every spreadsheet in our directory goes through a verification process. We check seller ratings, review histories, and community feedback before listing. Spreadsheets marked with a "Verified" badge have passed our most rigorous quality checks.',
  },
  {
    question: 'Can I use these spreadsheets with Kakobuy or Superbuy?',
    answer: 'Absolutely. While the spreadsheets are often labeled as "CSSBuy spreadsheets," the product links work with any agent — CSSBuy, Kakobuy, Superbuy, Oopbuy, and others. We also maintain separate directories for each platform so you can find agent-specific deals and guides.',
  },
  {
    question: 'How do I find specific brands like Nike or Jordan?',
    answer: 'Navigate to our Brands section where we organize spreadsheets by brand. Each brand page (Nike, Jordan, Adidas, etc.) contains category-specific spreadsheets — Nike shoes, Jordan hoodies, and so on — so you can drill down to exactly what you want.',
  },
  {
    question: 'Is there a cost to use these spreadsheets?',
    answer: 'No — every spreadsheet in our directory is completely free to access and use. We built this resource to help the community find quality products without paying for access. Simply browse, click through to the spreadsheet, and start shopping.',
  },
  {
    question: 'What is the difference between CSSBuy and Kakobuy?',
    answer: 'CSSBuy and Kakobuy are both popular shopping agents that help international buyers purchase from Chinese marketplaces. CSSBuy is known for competitive shipping rates and extensive QC photo options, while Kakobuy offers a more streamlined interface and slightly faster processing. Both support spreadsheet-based shopping. Check our comparison pages for detailed breakdowns.',
  },
  {
    question: 'How do I submit my own spreadsheet to the directory?',
    answer: 'We welcome community contributions! Reach out through our contact form with your spreadsheet link, and our team will review it for quality and accuracy. Approved spreadsheets are added to the directory within 24-48 hours.',
  },
  {
    question: 'Which agent has the best shipping prices?',
    answer: 'Shipping prices vary by destination, package weight, and shipping line. CSSBuy generally offers the most shipping line options with competitive rates for most destinations. Superbuy has strong rates for smaller packages, while Kakobuy excels for certain European routes. We recommend comparing rates across agents for your specific order.',
  },
  {
    question: 'Can I find replica or rep items in these spreadsheets?',
    answer: 'Our directory indexes product links and spreadsheets shared by the community. We do not specifically categorize items as replicas or authentic — the spreadsheets contain a mix of both. Always review seller descriptions and QC photos carefully before purchasing.',
  },
];